import React from 'react'
import {
   makeStyles,
   FormControlLabel,
   RadioGroup,
   Radio
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   listContainer: {
      marginBottom: theme.spacing(3)
   }
}))

const RadioButtonsGroup = ({ name, items, value, handleSelection }) => {
   const classes = useStyles()
   return (
      <RadioGroup
         className={classes.listContainer}
         aria-label={name}
         name={name}
         value={value}
         onChange={handleSelection}
      >
         {items &&
            items.length &&
            items.map(item => (
               <FormControlLabel
                  key={item.id}
                  value={item.id}
                  label={item.name}
                  control={<Radio color="primary" />}
               />
            ))}
      </RadioGroup>
   )
}

export default RadioButtonsGroup
